import { Component, ElementRef, Inject, OnDestroy, OnInit, ViewChild, ViewChildren } from '@angular/core';
import { Router } from '@angular/router';
import { SnotifyService } from 'ng-snotify';
import { Observable, Subject } from 'rxjs';
import { Config } from '../../config/config';
import { RestDataService } from '../../service/rest-data.service';
import { SharedDataService } from '../../service/shared-data.service';
import { StaticDataService } from '../../service/static-data.service';
import { StaticViewDataService } from '../../service/static-view-data-service.service';
import * as Stomp from 'stompjs';
import * as SockJS from 'sockjs-client';
import { LocalstorageService } from '../../service/localstorage.service';
import { saveAs } from 'file-saver';
import { DomSanitizer } from '@angular/platform-browser';
import { cloneDeep } from 'lodash';
import { debounceTime, distinctUntilChanged } from 'rxjs/operators';
import { Download } from './download';
import { DownloadService } from './download.service';
import { DOCUMENT } from '@angular/common';

@Component({
  selector: 'app-all-video-cms-listing',
  templateUrl: './all-video-cms-listing.component.html',
  styleUrls: ['./all-video-cms-listing.component.scss']
})
export class AllVideoCmsListingComponent implements OnInit, OnDestroy {

  by_Author;
  getDataUrl = '';
  metaDataUrl = '';
  @ViewChild('listingInput', {static: false}) searchInput: ElementRef;
  channelList :any;
  socketsAllowed = [];
  filterList = [];
  facets = null;
  pageNum = 0;
  listArray = [];
  listIdArray = [];
  noresults = false;
  private stompClient;
  pageSize = 100;
  pageSizeArray = [10, 50, 100, 150, 200];
  sortByValueOf = null;
  filterUrl = {};
  fields = '';
  initialUrl = '';
  latestUrl = '';
  callFail = false;
  pages = 0;
  totalRecords = 0;
  str = '';
  searchFocus = false;
  @ViewChildren('listingInput') searchField;
  showMore = false;
  headerList = [];
  openPreviewItem = false;
  routeLinkForList;
  trustedHTML;
  saranyuHTML;
  saranyuId;
  saranyuEmbed;
  hasSaranyuVideo : boolean = false;
  hasYoutubeVideo : boolean = false;
  monthNames = [
    'Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun',
    'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'
  ];
  @ViewChildren('listData2') listData: ElementRef;
  timings = {
    constr: 0,
    onin: 0,
    resp: 0,
    list: 0,
    getEnv: 0,
    getMeta: 0
  };
  unlockPopup = false;
  lockedUser = '';
  lockedId = null;
  private subject: Subject<string> = new Subject();
  togglePage = null;
  domainConfig = null;
  isSubNavEnabled = false;
  enableSaranyu: boolean;
  download$: Map<String,Observable<Download>> = new Map<String,Observable<Download>>();
  constructor(
    private config: Config,
    private restService: RestDataService,
    private snotify: SnotifyService,
    private sharedService: SharedDataService,
    private router: Router,
    private localstorageService:LocalstorageService,
    private sanitizer: DomSanitizer,
    private downloads: DownloadService,
    @Inject(DOCUMENT) private document: Document

  ) {
    this.timings.constr = performance.now();
    console.log('constructor => 0');
    this.sharedService.getCurrentDomainConfig(this.getDomainConfig.bind(this));
    this.enableSaranyu = this.domainConfig['config']['story']['enableSaranyu'];

  }
  ngOnDestroy(): void {
    
  }

  getDomainConfig(currentDomainConfig) {
    this.domainConfig = currentDomainConfig;
  }

  downloadReport(item) {
    // // console.log(item)
    // if(item.longVideoS3Url) {
    //   saveAs(item.longVideoS3Url, "abc.mp4");
    //   // window.open(item.longVideoS3Url, "_blank");
    // } else {
    //   this.snotify.error('Video URL not found', '', this.sharedService.getConfig(false));
    // }
    if(item.longVideoS3Url) {
      let fileName = item.longVideoS3Url.substring(item.longVideoS3Url.lastIndexOf('/')+1,item.longVideoS3Url.length);
      // let fileName = item.longVideoS3Url.substring(item.longVideoS3Url.lastIndexOf('/')+1,item.longVideoS3Url.lastIndexOf('_')) + 
      // item.longVideoS3Url.substring(item.longVideoS3Url.lastIndexOf('.'),item.longVideoS3Url.length);
      this.download(fileName,item.longVideoS3Url,item.id);
    } else {
      this.snotify.error('Video URL not found', '', this.sharedService.getConfig(false));
    }
    
  }

  openPreview(item){
    this.trustedHTML = '';
    this.openPreviewItem = true;
    if(item.primaryYoutubeVideo && item.primaryYoutubeVideo.standardEmbedCode){
    this.trustedHTML = this.makeRenderable(cloneDeep(item.primaryYoutubeVideo.standardEmbedCode));
    this.hasYoutubeVideo = true;
  }
    if(item.saranyuVideo && item.saranyuVideo.embed_player){
      this.hasSaranyuVideo = true;
      const iframeRegex = /<iframe.*?>(.*?)<\/iframe>/is;
      const match = item.saranyuVideo.embed_player.match(iframeRegex);
      // Extracted URL from the src attribute
      const extractedURL = match ? match[0] : '';
      // Bind the extracted URL to the saranyuHTML variable
      this.saranyuEmbed = extractedURL;
      this.saranyuHTML = this.makeRenderable(cloneDeep(this.saranyuEmbed));
      this.saranyuId = item.saranyuVideo.asset_id;
  }
  }
  copyFunction(text) {
    const selBox = document.createElement('textarea');
    selBox.value = String(text);
    selBox.style.position = 'fixed';
    selBox.style.left = '0';
    selBox.style.top = '0';
    selBox.style.opacity = '0';
    document.body.appendChild(selBox);
    selBox.focus();
    selBox.select();
    document.execCommand('copy');
    document.body.removeChild(selBox);
    this.snotify.info('Text copied to Clipboard', '', this.sharedService.getConfig(false));
  }

  closePreview() {
    this.openPreviewItem = false;
    this.hasSaranyuVideo = false;
    this.hasYoutubeVideo = false;
    this.saranyuHTML = '';
    this.saranyuEmbed = '';
    this.saranyuId = '';
  }

  makeRenderable(text) {
    return this.sanitizer.bypassSecurityTrustHtml(text);
  }

  ngOnInit() {
    this.getChannelList();
    this.timings.onin = performance.now();
    console.log('oninit => ', performance.now() - this.timings.constr);
 
    this.getDataUrl = this.config.get('product').videoCmsUrl + StaticViewDataService.video_cms_listing_View.urls.listing;
    const filters = StaticViewDataService.video_cms_listing_View.filters;
    this.filterList = filters;
    this.facets = StaticViewDataService.video_cms_listing_View.facets;
    this.metaDataUrl = this.config.get('product').baseUrl + StaticViewDataService.video_cms_listing_View.urls.meta
    //this.filterList = this.sharedService.getUpdatedFilters(filters);
    // this.fields = StaticViewDataService.video_cms_listing_View.fields;
    this.headerList = StaticViewDataService.video_cms_listing_View.headers;
    this.routeLinkForList = StaticViewDataService.video_cms_listing_View.list_router;

    this.timings.getEnv = performance.now();
    console.log('getEnv => ', performance.now() - this.timings.onin);


    if (this.searchInput) {
      this.searchInput.nativeElement.focus();
    }

    if (StaticViewDataService.Page_listing_View.sortBy) {
      this.sortByValueOf = StaticViewDataService.video_cms_listing_View.sortBy;
    }

    if (this.metaDataUrl && this.metaDataUrl.trim() !== '') {
     //page specific url cms-backend-service-mt/api/cms/page/meta
      this.restService.http_get(this.metaDataUrl)
        .subscribe(data => {
          this.facets = { ...data, ...this.facets };
        });
      // let metaData=this.localstorageService.getMetaData();
      // console.log('all-page-listing.componet metadata',metaData);
      // this.facets=metaData;  
    }
    this.timings.getMeta = performance.now();
    console.log('getmeta => ', performance.now() - this.timings.getEnv);

    this.getDefaultList(0, this.dataInsertion);

    this.subject.pipe(
      debounceTime(800),
      distinctUntilChanged())
      .subscribe(result => {
        this.searchResults(result, 0, this.dataInsertion);
      });
  }

  getChannelList(){
    this.callFail = true;
    let url = this.config.get('product').videoCmsUrl + "/api/cms/video/getMasterData"
    this.restService.http_get(url)
    .subscribe(data => {
      this.channelList = data.channels;
      this.callFail = false;
      console.log("response", this.channelList)
    });
  }

  searchResults(query, pageNum, callback) {
    if (query && query.trim() !== '') {
      let url = this.getDataUrl + '?page=' + pageNum + '&size=' + this.pageSize;
      if (this.sortByValueOf) {
        url += '&sort=' + this.sortByValueOf + ',desc';
      }
      //url += this.fields;
      url += '&search=';
      if (this.filterUrl) {
        for (const filter in this.filterUrl) {
          if (filter) {
            url += this.filterUrl[filter];
          }
        }
      }
      const querArr = query.split(':');
      if (querArr && querArr.length > 1 && querArr[0].toUpperCase() === 'ID') {
        url += ',id:' + querArr[1].trim();
      } else {
        url += ',cmsVideoMetadata.videoTitle~' + StaticDataService.encodeSpecialChar(query);
      }
      this.callFail = false;
      this.latestUrl = url;
      this.timings['firstGet'] = performance.now();
      console.log('firstGet => ', performance.now() - this.timings.getMeta);
      this.restService.http_get(url)
        .subscribe(data => {
          this.timings.resp = performance.now();
          console.log('response received => ', performance.now() - this.timings['firstGet']);
          this.pages = data['totalPages'] > 20 ? 20 : data['totalPages'];
          this.totalRecords = data['totalElements'];
          this.topFunction();
          this.callFail = false;
          this.measureTime(0);
          callback(data);
        },
          error => {
            this.callFail = true;
            // console.log(error);
          });
    } else {
      this.getDefaultList(pageNum, data => {
        callback(data);
      });
    }
  }

  getDefaultList(pageNum, callback) {
    let url = this.getDataUrl + '?page=' + pageNum + '&size=' + this.pageSize;
    if (this.sortByValueOf) {
      url += '&sort=' + this.sortByValueOf + ',desc';
    }
    //url += this.fields;
    url += '&search=';
    if (this.filterUrl) {
      for (const filter in this.filterUrl) {
        if (filter) {
          url += this.filterUrl[filter];
        }
      }
    }
    this.callFail = false;
    if (this.initialUrl === '') {
      this.initialUrl = url;
    }
    this.latestUrl = url;
    this.timings['firstGet'] = performance.now();
    console.log('firstGet => ', performance.now() - this.timings.getMeta);
    this.restService.http_get(url)
      .subscribe(data => {
        this.timings.resp = performance.now();
        console.log('response received => ', performance.now() - this.timings['firstGet']);
        this.pages = data['totalPages'] > 20 ? 20 : data['totalPages'];
        this.totalRecords = data['totalElements'];
        this.callFail = false;
        this.topFunction();
        this.measureTime(0);
        callback(data);
      });
  }

  dataInsertion = (data) => {
    const results = data['content'];
    this.listArray = [];
    this.listIdArray = [];
    if (results && results.length > 0) {
      this.listArray = results;
      this.listIdArray = results.map(e => e.id);
      this.noresults = false;
    } else {
      this.noresults = true;
    }
  }

  topFunction() {
    document.body.scrollTop = 0; // For Safari
    if (document.getElementsByClassName('contentList') && document.getElementsByClassName('contentList').length > 0) {
      document.getElementsByClassName('contentList')[0].scrollTop = 0; // For Chrome, Firefox, IE and Opera
    }
  }

  arrayOne(n: number) {
    return Array(n);
  }

  onPageNumberChange(pagenum) {
    this.pageNum = pagenum;
    this.searchResults(this.str, this.pageNum, this.dataInsertion);
  }

  onPageSizeChange(size) {
    this.pageNum = 0;
    this.pageSize = size;
    this.searchResults(this.str, this.pageNum, this.dataInsertion);
  }

  onKeydown(event, input) {
    this.subject.next(input.value);
  }

  getFilterData(facet_name) {
    if (this.facets && this.facets[facet_name]) {
      return this.facets[facet_name];
    } else {
      return null;
    }
  }

  urlUpdate(ev) {
    this.filterUrl[ev.type] = ev.data;
    this.pageNum = 0;
    this.searchResults(this.str, this.pageNum, this.dataInsertion);
  }

  checkFocusInside(elem) {
    return (elem && elem.contains(document.activeElement));
  }


  getFullDate(seconds) {
    if (seconds) {
      const date = new Date(seconds);
      return '' + this.monthNames[date.getMonth()] + ' ' + date.getDate() + ', ' + ' ' + date.getFullYear() + ', ' +
        ((date.getHours() < 10) ? '0' + date.getHours() : date.getHours()) + ':'
        + ((date.getMinutes() < 10) ? '0' + date.getMinutes() : date.getMinutes());
    } else {
      return 'not present';
    }
  }

  getNewTypeDate(datestring) {
    if (datestring) {
      if (typeof datestring === 'string') {
        const dt = new Date(datestring.replace('+0000', 'Z'));
        return this.getFullDate(Math.round(dt.getTime()));
      } else {
        return this.getFullDate(datestring);
      }
    } else {
      return 'not present';
    }
  }

  getclassonCondition(lockStatus, storyStatus) {
    let ulClass = null;
    if (lockStatus && storyStatus === 'DONE') {
      ulClass = 'publishlockedIcon';
    } else if (lockStatus) {
      ulClass = 'lockedIcon icon-lock';
    } else if (storyStatus === 'DONE') {
      ulClass = 'publishIcon icon-published';
    }
    return ulClass;
  }


  measureTime(count) {
    if (this.listData && this.listData['length'] === this.pageSize) {
      this.timings.list = performance.now();
      console.log('list loaded => ', performance.now() - this.timings.resp);
      console.log('total first load time => ', performance.now() - this.timings.constr);
    } else if (count < 6) {
      setTimeout(e => {
        this.measureTime(++count);
      }, 0);
    }
  }

  download( name: string, url: string, id: string ) {
    //this.download$ = this.downloads.download(url, name);
    this.download$.set(id,this.downloads.download(url, name));
  }
}
